import { isEqual } from 'lodash'

import { SendingTypes } from '@sigmasms/shared-types'

import { proxy } from '@/utils'

import render from './render'

export default {
  name: 'RulesGeneratorFallback',

  mixins: [ proxy({ type: 'object' }) ],

  props: {
    readonly: {
      type: Boolean,
      default: false
    }
  },

  watch: {
    'proxy.type'() {
      switch (this.proxy.type) {
        case SendingTypes.viber: {
          this.proxy.payload.buttons = undefined
          this.proxy.payload.button = {
            url: undefined,
            text: undefined
          }
          break
        }
        case SendingTypes.vk:
        case SendingTypes.whatsapp: {
          this.proxy.payload.button = undefined
          this.proxy.payload.buttons = []
          break
        }

        default: {
          this.proxy.payload.button = undefined
          this.proxy.payload.buttons = undefined
          break
        }
      }
    }
  },

  methods: {
    watchValueHandler() {
      const nextValue = this._inputFilter(this.value)
      if (isEqual(this.proxy, nextValue)) {
        return
      }

      this.receiveValue()
    }
  },

  render
}
